import React, { ReactNode, useState } from 'react';

import { styled } from '@mui/material/styles';

import { Box } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { drawerHeaderMinHeight, appBarActualHeight } from '../../common/MetaSetting';

const headerMinHeight = drawerHeaderMinHeight;

interface ILayoutProps {
  children: NonNullable<ReactNode>;
}

export const LayoutContent = ({ children }: ILayoutProps) => {
  const { t, i18n } = useTranslation();

  return (
    <Box component="main" sx={{ 
      flexGrow: 1, 
      width: '100%', 
      // 对齐 memo-flutter:主内容区背景 = scaffold background(浅白/深黑)
      backgroundColor: 'background.default',
      height: `calc(100vh - ${appBarActualHeight})`,
      display: 'flex',
      flexDirection: 'column',
      mt: appBarActualHeight,
      boxSizing: 'border-box'
    }}>
      {children}
    </Box>
  );
};
